// The host page can override the build-time settings on the container, so one
// build serves whichever site embeds it. The Umbraco 17 site (Web.Site) serves
// the API from its own origin and the build from /fatalities-dashboard.
const container = document.getElementById('fatalities-dashboard-container');

export const apiHost = container?.dataset.apiHost || process.env.REACT_APP_API_HOST || '/api/';

/** Where public/ (the PDF logos) was deployed; PUBLIC_URL unless the page says otherwise. */
export const assetBase = container?.dataset.assetBase ?? process.env.PUBLIC_URL;
